import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  effect,
  input,
} from '@angular/core';
import { BackgroundAnimationAsset } from '@shared/models/background-animation.model';
import { buildBackgroundAnimationSrcdoc } from './background-animation.security';

@Component({
  selector: 'od-background-animation',
  standalone: true,
  templateUrl: './background-animation.component.html',
  styleUrls: ['./background-animation.component.scss'],
})
export class BackgroundAnimationComponent implements AfterViewInit {
  public readonly animation = input<BackgroundAnimationAsset | null>(null);

  @ViewChild('frame')
  private frameRef?: ElementRef<HTMLIFrameElement>;

  public srcdoc = '';
  private viewInitialized = false;
  // Discards stale async builds when the animation input changes mid-flight
  private buildToken = 0;

  constructor() {
    effect(() => {
      const animation = this.animation();
      const token = ++this.buildToken;

      void buildBackgroundAnimationSrcdoc(animation).then(nextSrcdoc => {
        if (token !== this.buildToken || nextSrcdoc === this.srcdoc) {
          return;
        }

        this.srcdoc = nextSrcdoc;
        this.renderSrcdoc();
      });
    });
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.renderSrcdoc();
  }

  private renderSrcdoc(): void {
    const iframe = this.frameRef?.nativeElement;

    if (!iframe || !this.viewInitialized) {
      return;
    }

    const nextSrcdoc = this.srcdoc ?? '';

    if (iframe.srcdoc !== nextSrcdoc) {
      iframe.srcdoc = nextSrcdoc;
    }
  }
}
